import { Button, Flex, Modal, useMobileMediaQuery } from '@iheartjane/reefer';
import { pluralize } from '@iheartjane/utils';

import type { FilterModalFooterProps } from './filterModal.types';

export const FilterModalFooter = ({
  hideClear = false,
  isLoading,
  onDeselect,
  onClose,
  totalResults,
  variant,
}: FilterModalFooterProps) => {
  const isMobile = useMobileMediaQuery({});
  const isSmallestMobile = useMobileMediaQuery({ size: 'sm', width: 'max' });

  const countLabel = pluralize({
    kilo: true,
    noun: variant,
    number: totalResults || 0,
  });

  const noResultsLabel = `${countLabel} ${!isMobile ? 'available' : ''}`;

  const buttonLabel =
    totalResults === 0 ? noResultsLabel : `Show ${countLabel}`;

  return (
    <Modal.Footer>
      <Flex gap={16} flexDirection={isSmallestMobile ? 'column' : 'row'}>
        {!hideClear && (
          <Button
            label="Clear all"
            variant="tertiary"
            full
            onClick={() => onDeselect('all')}
          />
        )}
        <Button
          label={buttonLabel}
          full
          onClick={onClose}
          data-testid={`show-${variant}-button`}
          loading={isLoading || totalResults === undefined}
          disabled={totalResults === 0}
        />
      </Flex>
    </Modal.Footer>
  );
};
